import { InGameCouponReducer } from 'features/customerPanel/cpCoupons/store/cpCoupons.reducer';
import avatarReducer from 'features/customerPanel/cpPlayerProfile/store/playerProfile.reducer';
import { CpPanelReducer } from 'features/customerPanel/store/cpPanel.reducer';
import { NAMESPACE as DICTIONARIES_NAMESPACE } from 'features/dictionaries/store/interface';
import { DictionariesReducer } from 'features/dictionaries/store/reducer';
import eventLiveReducer from 'features/eventLive/store/eventLive.reducer';
import eventPreMatchReducer from 'features/eventPreMatch/store/sportPrematch.reducer';
import { homeReducer } from 'features/Home';
import { LiveReducer } from 'features/live/store/live.reducer';
import loginReducer from 'features/login/store/login.reducer';
import { OffersReducer } from 'features/offers/store/offers.reducer';
import promotionDetailsReducer from 'features/promotion/store/promotionDetails.reducer';
import registerReducer from 'features/registration/store/register.reducer';
import { SportReducer } from 'features/sports/store/sport.reducer';
import { combineReducers } from 'redux';
import modalReducer from 'shared/components/Modal/store/modal.reducer';
import { LayoutReducer } from 'shared/hoc/store/layout.reducer';
import { Action, State } from 'shared/interface';
import { CouponReducer } from 'shared/store/coupon.reducer';
import { navigationReducer } from 'shared/store/navigation.reducer';
import { PlacementReducer } from 'shared/store/placement';
import { CategoriesReducer } from './categories';
import { commonReducer } from './common.reducer';
import { CookieReducer } from './cookie.reducer';
import couponOverviewReducer from './couponOverviewPanel.reducer';
import drawerReducer from './drawer.reducer';
import loadingReducer from './loading.reducer';

const appReducer = combineReducers({
	home: homeReducer,
	loading: loadingReducer,
	login: loginReducer,
	navigation: navigationReducer,
	coupon: CouponReducer,
	layout: LayoutReducer,
	live: LiveReducer,
	sport: SportReducer,
	placements: PlacementReducer,
	cpPanel: CpPanelReducer,
	offers: OffersReducer,
	[DICTIONARIES_NAMESPACE]: DictionariesReducer,
	categories: CategoriesReducer,
	cookie: CookieReducer,
	registerModal: registerReducer,
	eventPreMatchData: eventPreMatchReducer,
	eventLiveData: eventLiveReducer,
	promotionDetails: promotionDetailsReducer,
	inGameCouponCount: InGameCouponReducer,
	playerProfile: avatarReducer,
	modal: modalReducer,
	bottomDrawer: drawerReducer,
	couponOverviewPanel: couponOverviewReducer,
	common: commonReducer,
});

const rootReducer = (state: State | undefined, action: Action): any => {
	if (action.type === 'LOGOUT') {
		state = undefined;
	}
	return appReducer(state, action);
};

export default rootReducer;
